import { ReactNode } from 'react';
import { useNavigate } from "react-router-dom";

import { Typography, Box } from '@mui/material';
import FadeAnimation from 'components/views/FadeAnimation';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ReactComponent as IcIturan } from 'assets/icons/ic-ituran.svg';
import { ReactComponent as IcShield } from 'assets/icons/ic-shield.svg';

import { Container, ContentBackground, ContentForm, ContentNavigate } from './styles';

type Params = {
    titleNav: string;
    children: ReactNode;
    background: string;
}

const ContentForgot = ({ titleNav, children, background }: Params) => {
    const navigate = useNavigate();

    return (
        <FadeAnimation>
            <Container>
                <ContentBackground background={background}>
                    <Box sx={{ position: 'absolute', top: '3.125rem' }}>
                        <IcIturan />
                    </Box>

                    <Typography fontSize='2rem' color='white' fontWeight={700} paddingBottom='3.56rem'>
                        ÁREA DO CLIENTE
                    </Typography>

                    <IcShield />
                </ContentBackground>

                <ContentForm>
                    {titleNav &&
                        <ContentNavigate onClick={() => navigate('/')}>
                            <ArrowBackIosNewIcon fontSize='small' />
                            <Typography fontSize='1.125rem' fontWeight={400} paddingTop='3px' paddingLeft='.6rem' sx={{ display: { xs: 'none', md: 'flex' } }}>
                                Início
                            </Typography>
                            <Typography fontSize='1.125rem' fontWeight={700} paddingTop='3px' paddingLeft='.6rem' sx={{ display: { xs: 'flex', md: 'none' }, color: 'white', textTransform: 'uppercase' }}>
                                {titleNav}
                            </Typography>
                        </ContentNavigate>
                    }

                    <Box sx={{ padding: { xs: '5.25rem 0 0', md: '3.75rem 2.125rem .5rem', width: '100%', height: '100%', overflow: 'auto' } }}>
                        {children}
                    </Box>
                </ContentForm>
            </Container>
        </FadeAnimation>
    );
}

export default ContentForgot;